// ============================================================
// Alpine: notification sound settings (web customer + creator)
// ============================================================

import Alpine from 'alpinejs';
import {
  getNotificationSoundState,
  loadNotificationSoundPrefs,
  playNotificationSound,
  saveNotificationSoundPrefs,
  setNotificationSoundPrefs,
} from '../utils/notificationSound.js';

Alpine.data('notificationSoundSettings', () => ({
  loading: true,
  saving: false,
  playSound: true,
  sound: 'uspatih_notif',
  available: ['uspatih_notif'],
  message: '',
  error: '',

  async init() {
    this.loading = true;
    this.error = '';
    try {
      const s = await loadNotificationSoundPrefs();
      this.playSound = !!s.play;
      this.sound = s.sound || 'uspatih_notif';
      this.available = s.available?.length ? s.available : [this.sound];
    } catch (e) {
      this.error = e?.response?.data?.message || 'Gagal memuat preferensi suara.';
    } finally {
      this.loading = false;
    }
  },

  async togglePlay(v) {
    this.playSound = !!v;
    setNotificationSoundPrefs({ play: this.playSound });
    await this.persist({ play_sound: this.playSound });
  },

  async pickSound(name) {
    if (!name || name === this.sound) return;
    this.sound = name;
    setNotificationSoundPrefs({ sound: name, play: true });
    this.playSound = true;
    await this.persist({ notification_sound: name, play_sound: true });
    playNotificationSound({ force: true });
  },

  async persist(patch) {
    this.saving = true;
    this.message = '';
    this.error = '';
    try {
      await saveNotificationSoundPrefs(patch);
      this.message = 'Preferensi suara disimpan.';
      const s = getNotificationSoundState();
      this.playSound = !!s.play;
      this.sound = s.sound;
    } catch (e) {
      this.error = e?.response?.data?.message || 'Gagal menyimpan preferensi suara.';
    } finally {
      this.saving = false;
    }
  },

  preview() {
    playNotificationSound({ force: true });
  },
}));
